import { apiRequest } from "../services/apiRequest"

/**
 * Privacy Policy / Terms and Conditions stored in English and Arabic.
 * Gated by the `site_policies` permission module (id 16). The marketing site
 * reads the same rows from the public GET /api/site-policies/<key>/ endpoint,
 * so a saved change is live immediately.
 */
export const SITE_POLICY_KEYS = ["privacy_policy", "terms_and_conditions"]

/** Fields the backend accepts on PATCH; `key` and `time_updated` are read-only. */
export const SITE_POLICY_EDITABLE_FIELDS = [
  "title_en",
  "title_ar",
  "content_en",
  "content_ar",
]

export const SitePoliciesApi = {
  /** GET /api/admin/site-policies/ — both pages in one list. */
  getSitePolicies: async () => {
    return await apiRequest("get", "/api/admin/site-policies/", undefined, {
      skipCache: true,
    })
  },

  /** GET /api/admin/site-policies/<key>/ */
  getSitePolicy: async (key) => {
    return await apiRequest(
      "get",
      `/api/admin/site-policies/${encodeURIComponent(key)}/`,
      undefined,
      { skipCache: true }
    )
  },

  /** PATCH /api/admin/site-policies/<key>/ — send only the fields that changed. */
  updateSitePolicy: async (key, data) => {
    return await apiRequest(
      "patch",
      `/api/admin/site-policies/${encodeURIComponent(key)}/`,
      data,
      { skipCache: true }
    )
  },
}

export default SitePoliciesApi
